module.exports = __webpack_public_path__ + "img/feeling_blue.b3df24bc.svg";